'use client';

import type { ChangeEvent, KeyboardEventHandler } from 'react';
import { Icon } from '@/components/entities/Sprite';
import { Input } from '@/components/ui/Input/input';
import { cn } from '@/utils/cn';

interface SearchBarProps {
  placeholder: string;
  query: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  clearSearch: () => void;
  ref?: React.RefObject<HTMLInputElement | null>;
  className?: string;
};

const SearchBar = ({ ref, placeholder, query, className, onChange, onFocus, onKeyDown, clearSearch }: SearchBarProps) => {
  return (
    <div className={cn('relative', className)}>
      <Input
        placeholder={placeholder}
        value={query}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        className="pl-12 py-2.5 text-[1rem] font-normal 3xl:placeholder:text-[1.125rem] leading-6 pr-14.5 3xl:py-3"
        icon={<Icon name="search" className="text-c300 size-6" />}
        ref={ref}
      />

      {query && (
        <button
          onClick={clearSearch}
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 text-c200 p-2 bg-black/30 rounded-full"
          aria-label="Clear search"
        >
          <Icon name="x_close" className="size-3" />
        </button>
      )}
    </div>
  );
};

SearchBar.displayName = 'SearchBar';

export default SearchBar;
